import { useLocale } from '../i18n/LocaleContext';
import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import TermsPage from './TermsPage';
import PrivacyPage from './PrivacyPage';
import FAQsPage from './FAQsPage';
import SEO from '../components/SEO';

const TermsAndPrivacyPage = () => {
  const { t } = useLocale();
  const [activeTab, setActiveTab] = useState('terms');

  return (
    <PageContainer>
      <SEO
        title={t("footer.legalFaq")}
        description={t("seo.legal")}
        canonicalPath="/legal"
      />
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <PageTitle>{t('footer.legalFaq')}</PageTitle>

          <TabContainer>
            <Tab
              isActive={activeTab === 'terms'}
              onClick={() => setActiveTab('terms')}
            >
              {t('legal.terms')}
            </Tab>
            <Tab
              isActive={activeTab === 'privacy'}
              onClick={() => setActiveTab('privacy')}
            >
              {t('legal.privacy')}
            </Tab>
            <Tab
              isActive={activeTab === 'faqs'}
              onClick={() => setActiveTab('faqs')}
            >
              FAQs
            </Tab>
          </TabContainer>

          <TabContent>
            {activeTab === 'terms' ? <TermsPage /> :
             activeTab === 'privacy' ? <PrivacyPage /> :
             <FAQsPage />}
          </TabContent>
        </motion.div>
      </div>
    </PageContainer>
  );
};

const PageContainer = styled.section`
  padding: 100px 0;
  background-color: white;

  .container {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 40px;
  color: var(--primary);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  border-bottom: 1px solid var(--light-gray);
`;

const Tab = styled.button`
  padding: 15px 30px;
  font-size: 1.1rem;
  font-weight: 600;
  background: none;
  border: none;
  cursor: pointer;
  color: ${props => props.isActive ? 'var(--primary)' : 'var(--dark-gray)'};
  border-bottom: 3px solid ${props => props.isActive ? 'var(--primary)' : 'transparent'};
  transition: var(--transition);

  &:hover {
    color: var(--primary);
  }

  @media (max-width: 576px) {
    padding: 10px 15px;
    font-size: 1rem;
  }
`;

const TabContent = styled.div`
  min-height: 400px;
`;

export default TermsAndPrivacyPage;